import useLanguage from '@snowit/system/useLanguage';

import Typo from '../../Typography/Typo';

import s from './Calendar.module.scss';

export interface ICalendarWeekdays {
  weekdays: string[];
}

const CalendarWeekdays = (props: ICalendarWeekdays) => {
  const { weekdays } = props;
  const { t } = useLanguage();

  return (
    <div className={s.wrapWeekday}>
      {weekdays.map((wd, i) => {
        const isWeekend = i >= weekdays.length - 2;
        return (
          <Typo
            key={wd}
            className={s.weekDay}
            text={t(`lzy.time.full_day.${wd}`).slice(0, 3)}
            size={'sm'}
            weight={isWeekend ? 'medium' : 'regular'}
            color={isWeekend ? 'text' : 'text-l'}
          />
        );
      })}
    </div>
  );
};

export default CalendarWeekdays;
